// extracted by mini-css-extract-plugin
export default {"button":"AddNew_button__i4n+N"};